import { isString } from 'lodash';

import { ValidationRule } from '@/mixins/validation/validator';

export const minLength: (min: number) => ValidationRule = min => value => {
	const isValid = isString(value) && value.trim().length >= min;

	return isValid || `Should be at least ${min} characters`;
};
